import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Paths from './route_paths';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: Paths.START,
    name: 'Start',
    component: () => import('../components/Start.vue'),
  },
  {
    path: Paths.LOGIN,
    name: 'Login',
    component: () => import('../components/Login.vue'),
  },
  {
    path: Paths.BB_APP,
    name: 'Bluebird App',
    component: () => import('../components/app/BbApp.vue'),
    children: [
      {
        path: Paths.WELCOME,
        name: 'Welcome',
        component: () => import('../components/app/Welcome.vue'),
      },
      {
        path: Paths.LEVELS,
        name: 'Levels',
        component: () => import('../components/app/Levels.vue'),
      },
      {
        path: Paths.COURSES_PERSONALIZED,
        name: 'CoursesPersonalized',
        component: () => import('../components/app/CoursesPersonalized.vue'),
      },
      {
        path: Paths.COURSES_PERSONALIZED_WIZARD,
        name: 'CoursesPersonalizedWizard',
        component: () => import('../components/app/CoursesPersonalizedWizard.vue'),
      },
      {
        path: Paths.RAPID_TEST_INSTRUCTIONS,
        name: 'RapidTestInstructions',
        component: () => import('../components/app/RapidTestInstructions.vue'),
      },
      {
        path: Paths.RAPID_TEST_RESULTS,
        name: 'RapidTestResults',
        component: () => import('../components/app/RapidTestResults.vue'),
      },
      {
        path: Paths.RAPID_TEST,
        name: 'RapidTest',
        component: () => import('../components/app/RapidTest.vue'),
      },
      {
        path: Paths.LEVELS_PERSONALIZED,
        name: 'LevelsPersonalized',
        component: () => import('../components/app/LevelsPersonalized.vue'),
      },
      {
        path: Paths.UNITS,
        name: 'Units',
        component: () => import('../components/app/Units.vue'),
      },
      {
        path: Paths.LESSONS,
        name: 'Lessons',
        component: () => import('../components/app/Lessons.vue'),
      },
      {
        path: Paths.AUDIO,
        name: 'Audio',
        component: () => import('../components/app/Audio.vue'),
      },
      {
        path: Paths.QUIZZES,
        name: 'Quizzes',
        component: () => import('../components/quizzes/Quizzes.vue'),
      },
      {
        path: Paths.DRILLS,
        name: 'Drills',
        component: () => import('../components/drills/Drills.vue'),
        children: [
          {
            path: Paths.DRILL_FLASHCARDS,
            name: 'Drill Flashcards',
            component: () => import('../components/drills/DrillFlashcards.vue'),
          },
          {
            path: Paths.DRILL_VOICECOMPARISON,
            name: 'Drill Voice Comparison',
            component: () => import('../components/drills/DrillsVoiceComparison.vue'),
          },
          {
            path: Paths.DRILL_PRONUNCIATIONANALYSIS,
            name: 'Drill Pronunciation Analysis',
            component: () => import('../components/drills/DrillsPronunciationAnalysis.vue'),
          },
          {
            path: Paths.DRILL_VIDEO,
            name: 'Drill Video',
            component: () => import('../components/drills/DrillVideo.vue'),
          },
        ],
      },
    ],
  },
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
});

export default router;
